import { Heading, VisuallyHidden } from "@ariakit/react";
import type { ReactNode } from "react";
import { button } from "../../common/common.css.ts";
import hearts from "./hearts.svg";
import spacegitsCover from "./spacegitsCover.jpg";
import { section } from "./style.css.ts";

export function DownloadButton(props: { href: string; children: ReactNode }) {
  const { children, href } = props;

  return (
    <a
      href={href}
      className={button({ size: "dynamic", theme: "moss" })}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      {children}
    </a>
  );
}

export function DownloadSection(props: {
  action: ReactNode;
  note?: ReactNode;
}) {
  const { action, note } = props;

  return (
    <div className={section.container}>
      <VisuallyHidden>
        <Heading>Download Space Gits</Heading>
      </VisuallyHidden>

      <div className={section.book}>
        <div className={section.bookCover}>
          {note}

          <img
            src={spacegitsCover}
            alt=""
            className={section.bookImage}
            width={600}
            height={842}
          />
        </div>
      </div>

      <div className={section.buttonContainer}>
        <img className={section.hearts} src={hearts} alt="" />

        {action}
      </div>
    </div>
  );
}
